import EventHub from '~/modules/event_hub.js';

function noop() {}

export function legacyRoot() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  return {};
}

export function ensureLegacyGlobals() {
  const root = legacyRoot();
  root.global = root.global || root;
  root.EventHub = root.EventHub || EventHub;
  root.Audiocrowd = root.Audiocrowd || {};
  return root;
}

export function existingLegacyEventHub() {
  return legacyRoot().EventHub || null;
}

export function legacyEventHub() {
  return ensureLegacyGlobals().EventHub || null;
}

export function legacyEventHubOn(eventName, handler) {
  const eventHub = legacyEventHub();
  if (!eventHub || typeof eventHub.on !== 'function') {
    return noop;
  }

  eventHub.on(eventName, handler);
  return function removeLegacyEventHubListener() {
    legacyEventHubOff(eventName, handler);
  };
}

export function legacyEventHubOff(eventName, handler) {
  const eventHub = legacyEventHub();
  if (!eventHub || typeof eventHub.off !== 'function') {
    return;
  }

  eventHub.off(eventName, handler);
}

export function legacyEventHubTrigger(eventName, ...args) {
  const eventHub = legacyEventHub();
  if (!eventHub || typeof eventHub.trigger !== 'function') {
    return;
  }

  eventHub.trigger(eventName, ...args);
}

export function cartPayloadFromEvent(data) {
  if (Array.isArray(data)) {
    const first = data[0];

    if (Array.isArray(first)) {
      return { items: first };
    }

    if (first && typeof first === 'object' && ('items' in first || 'conversion_tracking' in first)) {
      return first;
    }

    return { items: data.filter((item) => item && typeof item === 'object') };
  }

  return data && typeof data === 'object' ? data : {};
}

export function cartItemsFromEvent(data) {
  const payload = cartPayloadFromEvent(data);

  return Array.isArray(payload.items) ? payload.items : [];
}

const legacyEventHubProxy = {
  on: legacyEventHubOn,
  off: legacyEventHubOff,
  trigger: legacyEventHubTrigger
};

export default legacyEventHubProxy;
